<template>
  <div id="welcomeView">
    <div id="welcomeContentContainer">
      <div id="welcomeSideBanner" v-if="sideBannerUrl"> <!-- TODO: MAKE ALL OF THIS CONTENT DEPENDENT ON ROUND, LOGIN, AND/OR COMPLETION STATUS -->
        <template v-if="activeRound">
          <div id="sideBannerCurrentRound" class="side-banner-item">ROUND <span class="highlighted-banner-info">{{ (currentRound + 1) }}</span> OF {{ rounds.length }}</div>
          <div id="sideBannerRoundStartInfo" class="side-banner-item">
            STARTS:<br/>
            <span class="highlighted-banner-info" v-html="prettyTimestamp(activeRound.startTime)"></span>
          </div>
          <div id="sideBannerRoundEndInfo" class="side-banner-item">
            ENDS:<br/>
            <span class="highlighted-banner-info" v-html="prettyTimestamp(activeRound.endTime)"></span>
          </div>
        </template>
      </div>
      <div id="welcomeContent" :class="{ 'no-side-banner': !sideBannerUrl }">
        <div id="welcomeMessage" v-if="activeRound" v-html="activeRound.introMessage"></div>
        <div id="relativeStartTime" v-html="generateNextRoundMessage()"></div>
        <div id="startButton" class="game-button zoom-in-out" @click="startLogin" v-if="currentUser === null">
          Log In >>
        </div>
        <div id="startButton" class="game-button zoom-in-out" @click="startGame" v-else-if="activeRound">
          Start
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Howl } from 'howler'

export default {
  name: 'Welcome',
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'currentUser',
      'currentView',
      'currentRound',
      'rounds',
      'sideBannerUrl',
    ]),
    activeRound(){
      const theWelcomeView = this;
      return theWelcomeView.currentRound !== null ? theWelcomeView.rounds[theWelcomeView.currentRound] : null;
    },
  },
  methods: {
    ...mapActions([
      'onResize',
      'toggleLoginModal',
      'updateCurrentView'
    ]),
    prettyTimestamp(timestamp){
      let formattedDate = new Date((timestamp * 1000)).toLocaleDateString('en-US');
      let formattedTime = new Date((timestamp * 1000)).toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit'});
      return `${formattedDate}<br/>${formattedTime}`;
    },
    startLogin(){
      const theWelcomeView = this;
      if(!theWelcomeView.startSound){
        let tempSound = new Howl({
          src: ['./assets/common/audio/game_start.mp3'],
          volume: 1,
          onload: () => {
            theWelcomeView.startSound = tempSound;
            tempSound.play()
          },
          onloaderror: (id, error) => {
            console.log(error)
          }
        });
      }else{
        theWelcomeView.startSound.play()
      }
      theWelcomeView.toggleLoginModal()
    },
    startGame(){
      const theWelcomeView = this;
      if(!theWelcomeView.activeRound){
        return;
      }
      theWelcomeView.updateCurrentView('question')
    },
    generateNextRoundMessage(){
      const theWelcomeView = this;
      const msPerDay = (1000 * 60 * 60 * 24);

      if(theWelcomeView.rounds.length === 0){
        return '';
      }

      const curTime = Math.floor(Date.now());
      const sortedRounds = [...theWelcomeView.rounds].sort((roundA, roundB) => roundA.startTime - roundB.startTime);
      const firstRound = sortedRounds[0];
      const lastRound = sortedRounds[sortedRounds.length - 1];
      const gameStarted = (curTime > (firstRound.startTime * 1000));
      const gameConcluded = (curTime > (lastRound.endTime * 1000));

      if(!gameStarted){
        const daysTilStart = Math.floor(((firstRound.startTime * 1000) - curTime) / msPerDay);
        return `THE GAME IS NOT YET AVAILABLE.<br/>THE FIRST ROUND WILL START IN ${daysTilStart} ${daysTilStart > 1 ? 'DAYS' : 'DAY'}`;
      }

      if(gameConcluded){
        return `THE GAME HAS CONCLUDED.<br/>YOU MAY STILL LOG IN TO VIEW YOUR SCORE AND PLACEMENT.`;
      }

      if(theWelcomeView.activeRound){
        const remainingDays = Math.floor(((theWelcomeView.activeRound.endTime * 1000) - curTime) / msPerDay);
        return `THIS ROUND ENDS IN ${remainingDays} ${remainingDays > 1 ? 'MORE DAYS' : 'MORE DAY'}`;
      }

      const nextRound = sortedRounds.find(round => (round.startTime * 1000) > curTime);
      const remainingDays = nextRound ? Math.floor(((nextRound.startTime * 1000) - curTime) / msPerDay) : 0;
      return `THE ROUND HAS CONCLUDED.<br/>THE NEXT ROUND WILL START IN ${remainingDays} ${remainingDays > 1 ? 'DAYS' : 'DAY'}`;
    }
  },
  mounted(){

  },
  data(){
    return {
      startSound: null,
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #welcomeView{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  #welcomeView{
    width: 80%;
    margin: 0 auto;
    max-width: 1200px;
  }

  #welcomeContentContainer{
    display: flex;
    flex-direction: row;
  }

  #welcomeSideBanner{
    display: flex;
    flex-direction: column;
    align-items:center;
    justify-content: flex-start;
    padding-top: 20px;
    width: 100%;
    height: 489px;
    max-width: 233px;
    background-image: var(--quizwhiz-legacy-side-banner-image, none);
    background-size: contain;
    background-repeat: no-repeat;
    font-weight: bold;
    font-size: 18px;
    line-height: 1.2em;
  }

  >>> .side-banner-item .highlighted-banner-info{
    font-size: 22px;
  }

  .side-banner-item:first-child{
    margin-top: 10px;
  }

  .side-banner-item{
    text-align: center;
    margin-bottom: 20px;
  }


  #welcomeContent{
    padding: 10px;
/*    max-width: calc(100% - 233px);*/
  }

  #welcomeContent.no-side-banner{
    width: 100%;
  }

  #relativeStartTime{
    font-size: 10px;
    font-weight: bold;
    margin: 0 auto;
    max-width: 350px;
    margin-top: 50px;
    text-align: center;
    line-height: 1em;
  }

  #startButton{
    max-width: 250px;
    margin: 0 auto;
/*    margin-top: 50px;*/
    margin-top: 10px;
    font-size: 25px;
  }

  .zoom-in-out {
    animation: zoom-in-zoom-out 2s;
    animation-iteration-count: infinite;
  }

  @keyframes zoom-in-zoom-out {
    0% {
      transform: scale(1, 1);
    }
    50% {
      transform: scale(1.125, 1.125);
    }
    100% {
      transform: scale(1, 1);
    }
  }

  @media screen and (min-width: 737px) and (max-width: 796px){
    #welcomeSideBanner{
      font-size: 16px;
      line-height: 1em;
    }
    >>> .side-banner-item .highlighted-banner-info{
      font-size: 16px;
    }
  }

  @media screen and (max-width: 736px){
    #welcomeView{
      width: 100%;
    }
    #welcomeSideBanner{
      width: 120px;
      height: 330px;
      font-size: 12px;
      line-height: 1em;
    }
    >>> .side-banner-item .highlighted-banner-info{
      font-size: 12px;
    }
    #welcomeContent{
      position: relative;
      max-width: calc(100% - 120px);
    }
    #welcomeContent.no-side-banner{
      max-width: 100%;
    }
  }

 @media screen and (max-width: 475px){
    #welcomeContent{
      overflow-y: auto;
      height: calc(100vh - 200px);
      height: calc(100svh - 200px);
    }
  }
</style>
